import React from "react";
import { RESTRICTION_MAP } from "../constants/restrictions";

export default function RestrictionBadge({ type, size = "sm" }) {
  const meta = RESTRICTION_MAP[type];
  if (!meta) return null;
  const padding = size === "lg" ? "px-3 py-1.5 text-sm" : "px-2.5 py-1 text-xs";
  return (
    <span
      data-testid={`badge-${type}`}
      className={`inline-flex items-center gap-1 rounded-full font-bold ${padding}`}
      style={{ backgroundColor: meta.bg, color: meta.text }}
    >
      <span aria-hidden>{meta.emoji}</span>
      {meta.label}
    </span>
  );
}
